
export const AppMenus = {

  navbarTopRightItems: [],
  navbarTopLeftItems: [],
  navbarSideLeftItems: [
    {
      "to": "/home",
      "label": "Home",
      "icon": "pi pi-home text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/applicants",
      "label": "Applicants",
      "icon": "pi pi-id-card text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/applicants/admissions",
      "label": "Admission Offers",
      "icon": "pi pi-file text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/applicants/confirmed_admissions",
      "label": "Confirmed Admissions",
      "icon": "pi pi-check-square text-primary",
      "iconcolor": "",
      "target": "",

    },
    // {
    //   "to": "/institution_admissions_uploads",
    //   "label": "Admissions Uploads",
    //   "icon": "pi pi-cloud-upload text-primary",
    //   "iconcolor": "",
    //   "target": "",

    // },
    {
      "to": "/institution_campuses",
      "label": "Campuses",
      "icon": "pi pi-building text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/institution_schools",
      "label": "Departments",
      "icon": "pi pi-th-large text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/institution_programmes",
      "label": "Programmes",
      "icon": "pi pi-book text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/applicants/capsmall",
      "label": "CAPS Mall",
      "icon": "pi pi-shopping-cart text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/institution_accounts",
      "label": "Manage Accounts",
      "icon": "pi pi-users text-primary",
      "iconcolor": "",
      "target": "",
    },
    {
      "to": "/institution_account_roles",
      "label": "Account Roles",
      "icon": "pi pi-unlock text-primary",
      "iconcolor": "",
      "target": "",

    },
    {
      "to": "/caps_institutions_list/edit",
      "label": "Institution Setup Info",
      "icon": "pi pi-cog text-primary",
      "iconcolor": "",
      "target": "",

    },
    // {
    //   "to": "/capsoverview",
    //   "label": "CAPS Overview",
    //   "icon": "pi pi-video text-primary",
    //   "iconcolor": "",
    //   "target": "",

    // },
    {
      to: "/help",
      label: "Help and Support",
      icon: "pi pi-question-circle mr-2 text-primary",
      iconcolor: "",
      target: "",
    },
  ],
  account_typeItems: [
    {
      value: "Level 3",
      label: "Level 3",
      desc: [
        "User will have access to all pages",
        "User can create, modify or delete records on all pages",
        "User see all dashbaord stats"
      ]
    },
    {
      value: "Level 2",
      label: "Level 2",
      desc: [
        "User will only have access Home, Applicants, Admissions and CAPS Mall",
        "User can only modify records on specified pages"
      ]
    },
    {
      value: "Level 1",
      label: "Level 1",
      desc: [
        "User will only have access Home, Applicants, Admissions and CAPS Mall"
      ]
    },
  ],
  account_statusItems: [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
    { value: "Blocked", label: "Blocked" },
  ],
  yes_or_noItems: [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" }
  ],
  programme_sessionsItems: [
    { value: "Morning", label: "Morning" },
    { value: "Evening", label: "Evening" },
    { value: "Weekend", label: "Weekend" }
  ],
  programme_requisitesItems: [
    { value: "Entry Exams", label: "Entry Exams" },
    { value: "Interview", label: "Interview" },
  ],
  cohort_Items: [
    { value: "January", label: "January (Winter)" },
    { value: "March", label: "March to May (Spring)" },
    { value: "June", label: "June to August (Summer)" },
    { value: "September", label: "September (Autumn)" },
  ],
  programme_required_electivesItems: [
    { value: "Animal Husbandry", label: "Animal Husbandry" },
    { value: "Arts", label: "Arts" },
    { value: "Basketry", label: "Basketry" },
    { value: "Biology", label: "Biology" },
    { value: "Building Construction", label: "Building Construction" },
    { value: "Catering", label: "Catering" },
    { value: "Ceramics", label: "Ceramics" },
    { value: "Chemistry", label: "Chemistry" },
    { value: "Core Mathematics", label: "Core Mathematics" },
    { value: "Cost Accounting", label: "Cost Accounting" },
    { value: "Economics", label: "Economics" },
    { value: "Elective ICT", label: "Elective ICT" },
    { value: "Elective Mathematics", label: "Elective Mathematics" },
    { value: "Electronics", label: "Electronics" },
    { value: "Engineering", label: "Engineering" },
    { value: "English", label: "English" },
    { value: "English Literature", label: "English Literature" },
    { value: "Financial Accounting", label: "Financial Accounting" },
    { value: "Food & Nutrition", label: "Food & Nutrition" },
    { value: "French", label: "French" },
    { value: "General Agriculture", label: "General Agriculture" },
    { value: "General Knowledge in Arts", label: "General Knowledge in Arts" },
    { value: "General Textiles", label: "General Textiles" },
    { value: "Geography", label: "Geography" },
    { value: "Government", label: "Government" },
    { value: "Graphic Design", label: "Graphic Design" },
    { value: "History", label: "History" },
    { value: "Integrated Science ", label: "Integrated Science " },
    { value: "Leatherwork", label: "Leatherwork" },
    { value: "Management", label: "Management" },
    { value: "Management in Living", label: "Management in Living" },
    { value: "Metal Work", label: "Metal Work" },
    { value: "Photography", label: "Photography" },
    { value: "Physics", label: "Physics" },
    { value: "Picture Making", label: "Picture Making" },
    { value: "Plumbing Craft", label: "Plumbing Craft" },
    { value: "Religious Studies", label: "Religious Studies" },
    { value: "Sculpture", label: "Sculpture" },
    { value: "Social Studies", label: "Social Studies" },
    { value: "Textiles", label: "Textiles" },
    { value: "Woodwork", label: "Woodwork" },
  ],
  applicantsgenderItems: [{ "label": "Male", "value": "Male" }, { "label": "Female", "value": "Female" }],
  applicantsshs_courseItems: [{ "label": "Science", "value": "Science" }, { "label": "Business", "value": "Business" }, { "label": "Art", "value": "Art" }],
  institution_admissions_uploadsprocessing_statusItems: [{ "label": "Completed", "value": "Completed" }, { "label": "Pending", "value": "Pending" }],

  exportFormats: {
    print: {
      label: 'Print',
      icon: 'pi pi-print',
      type: 'print',
      ext: '',
    },
    pdf: {
      label: 'Pdf',

      icon: 'pi pi-file-pdf',
      type: 'pdf',
      ext: 'pdf',
    },
    excel: {
      label: 'Excel',
      icon: 'pi pi-file-excel',
      type: 'excel',
      ext: 'xlsx',
    },
    csv: {
      label: 'Csv',
      icon: 'pi pi-table',
      type: 'csv',
      ext: 'csv',
    },
  },

}